import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { AppConsts } from '@shared/app-consts';
import { BaseService } from './base.service';
import {
  EcfAnswer, EcfQuestionnaireDetail, EcfQuestionnaireSummary, EcfUploadFileResponse,
} from '@shared/models/ecf-questionnaire/ecf-questionnaire.model';

/** Routes relais ecfQuestionnaire de l'API de l'espace pro (spec 010, contrat R1–R7). */
@Injectable({
  providedIn: 'root',
})
export class EcfQuestionnaireService extends BaseService {
  private readonly baseUrl = AppConsts.API_SERVICE_URL + 'ecfQuestionnaire';

  constructor(private http: HttpClient) {
    super();
  }

  /** R1 */
  getMine(): Observable<EcfQuestionnaireSummary[]> {
    return this.http.get<EcfQuestionnaireSummary[]>(this.baseUrl, this.getHttpHeader());
  }

  /** R2 */
  get(id: number): Observable<EcfQuestionnaireDetail> {
    return this.http.get<EcfQuestionnaireDetail>(`${this.baseUrl}/${id}`, this.getHttpHeader());
  }

  /** R3 */
  saveAnswers(id: number, answers: Record<string, EcfAnswer>): Observable<EcfQuestionnaireDetail> {
    return this.http.put<EcfQuestionnaireDetail>(`${this.baseUrl}/${id}/answers`, { Answers: answers }, this.getHttpHeader());
  }

  /** R4 : multipart pointCode + file, comme client-request.service.ts. */
  addFile(id: number, pointCode: string, file: File): Observable<EcfUploadFileResponse> {
    const formData = new FormData();
    formData.append('pointCode', pointCode);
    formData.append('file', file, file.name);
    const httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "X-Requested-With": "XMLHttpRequest"
      })
    };
    return this.http.post<EcfUploadFileResponse>(`${this.baseUrl}/${id}/files`, formData, httpOptions);
  }

  /** R5 */
  deleteFile(id: number, documentId: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}/files/${documentId}`, this.getHttpHeader());
  }

  /** R6 */
  submit(id: number): Observable<EcfQuestionnaireDetail> {
    return this.http.post<EcfQuestionnaireDetail>(`${this.baseUrl}/${id}/submit`, { Certified: true }, this.getHttpHeader());
  }

  /** R7 : pièce ou accusé de réception. */
  downloadFile(id: number, documentId: number): Observable<{ fileName: string; document: Blob }> {
    return (this.http.get(`${this.baseUrl}/${id}/files/${documentId}`, this.getHttpHeader(true)) as Observable<any>)
      .pipe(map(response => this.getFileFromResponse(response)));
  }
}
